import * as React from 'react';

export const orderSuccessIcon = (
  <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <g id="Mobile" fill="none" fillRule="evenodd">
      <g id="M-/-Receipt" transform="translate(-156 -104)" stroke="#0027F4">
        <g id="Group-3" transform="translate(156 104)">
          <circle id="Oval-3" cx="24" cy="24" r="23.5" />
          <polygon
            id="Combined-Shape"
            strokeWidth="0.25"
            fill="#0027F4"
            points="21.6 32.027027 35.6 15 36 15.4864865 21.6 33 12 21.3243243 12.4 20.8378378"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const arrowNextIcon = (
  <svg
    width="8"
    height="12"
    viewBox="0 0 8 12"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <polygon
        id="path-1"
        points="12.41 4.41 11 3 5 9 11 15 12.41 13.59 7.83 9"
      />
    </defs>
    <g id="Mobile" fill="none" fillRule="evenodd">
      <g id="M-/-Receipt" transform="translate(-331 -976)">
        <g id="Group" transform="translate(175 973)">
          <g id="Group-2" transform="rotate(180 84.5 9)">
            <mask id="mask-2" fill="#fff">
              <use xlinkHref="#path-1" />
            </mask>
            <use
              id="icon/navigation/chevron_left_24px"
              fill="#0027F4"
              fillRule="nonzero"
              xlinkHref="#path-1"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/icons.tsx